import { useEffect, useState } from "react";

export interface UseCountDownOptions {
  intervalSeconds?: number;
  callback?: () => void;
}

export const useCountDown = ({
  intervalSeconds = 10,
  callback,
}: UseCountDownOptions) => {
  const [countdown, setCountDown] = useState(intervalSeconds);
  const [interval, _setInterval] = useState<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (0 === countdown) {
      callback && callback();
    }
  }, [countdown]);

  useEffect(() => {
    start();
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, []);

  const start = () => {
    _setInterval(
      setInterval(() => {
        setCountDown((count) => {
          if (count > 0) {
            return count - 1;
          }
          return count;
        });
      }, 1000)
    );
  };

  const clear = () => {
    if (interval) {
      clearInterval(interval);
      _setInterval(null);
      setCountDown(intervalSeconds);
    }
  };

  return {
    running: Boolean(interval),
    countdown,
    clear,
    start,
  };
};
